import { render, staticRenderFns } from "./FindologicItemSearch.vue?vue&type=template&id=3da511c5&scoped=true&"
import script from "./FindologicItemSearch.vue?vue&type=script&lang=ts&"
export * from "./FindologicItemSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da511c5",
  null
  
)

export default component.exports